__turbopack_context__.v({
  "review-layout-desk": "ReviewsDesktop-module-scss-module__LVGrQq__review-layout-desk",
});
